import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import App from './App.vue'
import router from './router';
import hl from 'highlight.js' // 导入代码高亮文件
import 'highlight.js/styles/github.css'
// global css
import './styles/scss/index.scss';

// 点击非当前元素触发指令  v-click-away="回调函数"
// https://github.com/VinceG/vue-click-away
import VueClickAway from "vue3-click-away";
import directive from '@/directive';
import autoRegisterComponents from './components';

// import 'reset.css'

let app = createApp(App)
app.directive('highlight', function (el) {
    const blocks = el.querySelectorAll('pre code')
    blocks.forEach((block) => {
        hl.highlightElement(block)
    })
})
app.use(VueClickAway);

app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})
// 自动注册全局自定义组件
autoRegisterComponents(app)
// 引入全局自定义指令
Object.keys(directive).forEach(item => {
    app.directive(item, directive[item]);
  });

app.mount('#app')
